import { ActionType } from "../action-types"
import { Actions } from "../actions"

interface createTokenState {
    loading: boolean
    payload?: any
}

export const defaultCreateTokenState: createTokenState = {
    loading: false
}

const createTokenReducer = (state: createTokenState = defaultCreateTokenState, action: Actions): createTokenState => {
    switch (action.type) {
        case ActionType.CREATE_TOKEN_REQUEST:
            return {
                loading: true
            }
        case ActionType.CREATE_TOKEN_FAILURE:
            return {
                loading: false,
                payload: action.error
            }
        case ActionType.CREATE_TOKEN_SUCCESS:
            return {
                loading: false,
                payload: action.payload
            }
        case ActionType.CLEAR_ALL:
            return {
                loading: false
            }
        default:
            return state
    }
}

export default createTokenReducer